import { render, staticRenderFns } from "./ScreenTime.vue?vue&type=template&id=63d52a73&scoped=true&"
import script from "./ScreenTime.vue?vue&type=script&lang=js&"
export * from "./ScreenTime.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTime.vue?vue&type=style&index=0&id=63d52a73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d52a73",
  null
  
)

export default component.exports